/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';

import { Middleware } from '../redux/middleware';
import * as Actions from './store/actions';
import RegistrationStoreReducer from './store/reducer';
import { RegistrationEditor } from './components/editor.jsx';

export class Editor {
        element = null;
        event_id = null;
        initial_data = null;

        constructor(element, event_id, initial_data) {
          this.triggerChange = this.triggerChange.bind(this);
          this.createStore = this.createStore.bind(this);
          this.element = element;
          this.event_id = event_id;
          this.initial_data = initial_data;

          this.store = this.createStore();

          this.react_element = ReactDOM.render(React.createElement(
            ReactRedux.Provider, {
              store: this.store
            }, React.createElement(RegistrationEditor)
          ), element);
        }

        // Handler to notify that the selected event experience changed
        eventExperienceChanged(experience) {
          return this.store.dispatch(Actions.eventExperienceChange({experience}));
        }


        // Handler to notify that the stream URL changed
        streamUrlChanged(stream_url) {
          return this.store.dispatch(Actions.eventStreamUrlChange({stream_url}));
        }

        // Handler to notify that the payout account ID changed
        eventPayoutAccountIdChanged(payout_account_id) {
          return this.store.dispatch(Actions.eventPayoutAccountIdChange({payout_account_id}));
        }

        triggerChange() {
          return this.element.dispatchEvent(new Event('change', {bubbles: true}));
        }


        // Create the Redux store and initialize it with the initial data provided
        createStore() {
          let store;
          const initial_state = _.extend({debug: true}, this.initial_data);

          const my = this;
          // Simple middleware for listening to the specified actions to emit a change event
          const changedActionEventMiddleware = store => next => (function(action) {
            let needle;
            const result = next(action);

            // Trigger a change event on all dispatcehd actions, except for the intermediate dragging ones
            // (This takes advantage of the fact that the action types all have the same naming structure.)
            // It matters that the _ is only included for _DRAG_START but not the rest, as it's just taking the suffix on the type.
            if ((needle = action.type.substr(-11), !['_DRAG_START', 'DRAG_CANCEL', 'DRAG_UPDATE'].includes(needle))) {
              my.triggerChange();
            }

            return result;
          });

          const middlewares = [
            Middleware.debounceMiddleware,
            Middleware.promiseMiddleware,
            Middleware.thunkMiddleware,
            changedActionEventMiddleware,
          ];
          if (Middleware.isDevelopment()) { middlewares.push(Middleware.loggerMiddleware); }

          // Coffeescript 1 doesn't support arguments splat
          const createStoreWithMiddleware = Redux.applyMiddleware.apply(null, middlewares)(Redux.createStore);

          return store = createStoreWithMiddleware(RegistrationStoreReducer,
            initial_state,
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
        }
}
